/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { PayPeriod1 } from './PayPeriod1';
import {
    PayPeriod1FromJSON,
    PayPeriod1FromJSONTyped,
    PayPeriod1ToJSON,
    PayPeriod1ToJSONTyped,
} from './PayPeriod1';

/**
 * 
 * @export
 * @interface ListRemainingPayPeriodsResponse
 */
export interface ListRemainingPayPeriodsResponse {
    /**
     * 
     * @type {Array<PayPeriod1>}
     * @memberof ListRemainingPayPeriodsResponse
     */
    data: Array<PayPeriod1>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListRemainingPayPeriodsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListRemainingPayPeriodsResponse interface.
 */
export function instanceOfListRemainingPayPeriodsResponse(value: object): value is ListRemainingPayPeriodsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListRemainingPayPeriodsResponseFromJSON(json: any): ListRemainingPayPeriodsResponse {
    return ListRemainingPayPeriodsResponseFromJSONTyped(json, false);
}

export function ListRemainingPayPeriodsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRemainingPayPeriodsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PayPeriod1FromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListRemainingPayPeriodsResponseToJSON(json: any): ListRemainingPayPeriodsResponse {
      return ListRemainingPayPeriodsResponseToJSONTyped(json, false);
  }

  export function ListRemainingPayPeriodsResponseToJSONTyped(value?: ListRemainingPayPeriodsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PayPeriod1ToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

